export enum ProjectStatus {
    DRAFT = "draft",
    FILE_UPLOADED = "file-uploaded",
    ADMIN_REVIEW = "admin-review",
    ADMIN_REJECTED = "admin-rejected",
    ACCEPTED_FOR_PROCESSING = "accepted-for-processing",
    SCRIPT_RUNNING = "script-running",
    INVALID_FILE = "invalid-file",
    RESULT_GENERATED = "result-generated",
    ADMIN_RESULT_REVIEW = "admin-result-review",
    REPORT_UPLOADED = "report-uploaded",
    DONE = "done",
}

export const PROJECT_STATUS_BADGES: Record<ProjectStatus, string> = {
    [ProjectStatus.DRAFT]:
        "bg-slate-800/60 text-slate-400 border border-slate-600",

    [ProjectStatus.FILE_UPLOADED]:
        "bg-blue-900/40 text-blue-400 border border-blue-500/40",

    [ProjectStatus.ADMIN_REVIEW]:
        "bg-yellow-900/40 text-yellow-400 border border-yellow-500/40",

    [ProjectStatus.ADMIN_REJECTED]:
        "bg-red-900/40 text-red-400 border border-red-500/40",

    [ProjectStatus.INVALID_FILE]:
        "bg-red-900/40 text-red-400 border border-red-500/40",

    [ProjectStatus.ACCEPTED_FOR_PROCESSING]:
        "bg-indigo-900/40 text-indigo-400 border border-indigo-500/40",

    [ProjectStatus.SCRIPT_RUNNING]:
        "bg-purple-900/40 text-purple-400 border border-purple-500/40",

    [ProjectStatus.RESULT_GENERATED]:
        "bg-teal-900/40 text-teal-400 border border-teal-500/40",

    [ProjectStatus.ADMIN_RESULT_REVIEW]:
        "bg-orange-900/40 text-orange-400 border border-orange-500/40",

    [ProjectStatus.REPORT_UPLOADED]:
        "bg-cyan-900/40 text-cyan-400 border border-cyan-500/40",

    [ProjectStatus.DONE]:
        "bg-green-900/40 text-green-400 border border-green-500/40",
};


export interface Project {
    id: string;
    userId: string;
    name: string;
    summary: string;
    status: ProjectStatus
    companyName: string | null;
    location: string | null;
    projectThumbnail: string | null;
    projectThumbnailPreview?: string | null;
    uploadControlPanelDoc?: string | null;
    /** Signed download URL for control panel doc (use this for DOWNLOAD control panel). */
    uploadControlPanelDocPreview?: string | null;
    /** Optional URL for CSV file download (when present, DOWNLOAD CSV is enabled). */
    csvFileUrl?: string | null;
    /** Report file URL or object (backend: ifc_model_report). Set when user uploads report from project view. */
    ifcModelReport?: string | { url?: string; name?: string } | null;
    /** Signed download URL for the report (backend adds this from ifcModelReport). Use this for DOWNLOAD CSV. */
    ifcModelReportPreview?: string | null;
    /** IFC model: single key (legacy), or array of S3 keys (backend: ifc_model). When set, IFC file(s) uploaded. */
    ifcModel?: string | string[] | { url?: string; name?: string } | null;
    /** Signed download URL(s) for IFC file(s), same order as ifcModel when array. */
    ifcModelPreview?: string | string[] | null;
    /** Report relation (backend). When present, report.reportUrl is the stored report file URL; report.reportUrlPreview is the signed download URL. */
    report?: { reportUrl?: string; reportUrlPreview?: string } | null;
    files: File[];
    createdAt: string;
    updatedAt: string;
}


type ProjectDetails = {
    name: string;
    summary: string;
    companyName: string;
    projectThumbnail: string;
    status: ProjectStatus;
    files: File[];
    userId?: string;
    assignedUserId?: string;
    location: string;
    uploadControlPanelDoc?: string | null;
};

type projectTouch = Partial<Record<keyof ProjectDetails, boolean>>;
type projectFieldErrors = Partial<Record<keyof ProjectDetails, string>>;

export { type ProjectDetails, type projectTouch, type projectFieldErrors }